import { UserPaymentStatus } from 'api/payments/getUserPayments'

const AUDIT_ACTION_LABELS: Record<string, string> = {
  CREATE_RECORD: 'Payout record created',
  SEND_TO_HIGHNOTE: 'Payout record sent to Highnote',
  MARK_AS_COMPLETED: 'Highnote notified payment as completed',
  MARK_AS_FAILED: 'Highnote notified payment as failed',
  MARK_AS_PENDING: 'Highnote notified payment as pending',
  MARK_AS_PROCESSING: 'Highnote notified payment as processing',
  MARK_AS_PROCESSED: 'Highnote notified payment as processed',
  MARK_AS_RETURNED: 'Highnote notified payment as returned',
  MARK_AS_CANCELED: 'Highnote notified payment as cancelled',
}

export const getAuditActionLabel = (action: string): string =>
  AUDIT_ACTION_LABELS[action] ?? 'Unknown action'

export const getPayoutStatusLabel = (status: UserPaymentStatus): string => {
  switch (status) {
    case UserPaymentStatus.COMPLETED:
      return 'Paid out'
    case UserPaymentStatus.PENDING:
      return 'Pay-out in progress'
    case UserPaymentStatus.FAILED:
      return 'Pay-out failed'
    case UserPaymentStatus.REVERSED:
      return 'Pay-out reversed'
    case UserPaymentStatus.CANCELED:
      return 'Pay-out canceled'
    default:
      return 'Pay-out status unknown'
  }
}
